import * as Sentry from "@sentry/react";

// Loaded before App so errors during application startup are captured too.
const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();

if (dsn && process.env.NODE_ENV !== "test") {
  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT?.trim() || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE?.trim() || undefined,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
    initialScope: { tags: { app: "hub" } },
  });
}
